import * as yup from 'yup';

/**
 * @name fromPhone
 * @description Takes a phone in the form of a string and converts it to a number e.g. (555) 555 - 5555 => 5555555555
 *
 */
yup.addMethod(yup.number, 'fromPhone', function () {
  return this.transform(function (value, originalValue) {
    if (typeof originalValue === 'number') {
      return originalValue;
    }

    if (originalValue) {
      // eslint-disable-next-line
      value = originalValue.match(/[0-9]+/g);
      return value ? Number(value.join('')) : 0;
    }

    return undefined;
  });
});

yup.addMethod(yup.number, 'phone', function (message) {
  return this.test('is-phone', message, function (value) {
    const { createError, schema } = this;

    // @ts-expect-error TS(2339): Property '_exclusive' does not exist on type 'Sche... Remove this comment to see the full error message
    if (typeof value === 'undefined' && schema._exclusive.required) {
      return createError(
        // @ts-expect-error TS(2551): Property '_label' does not exist on type 'Schema<a... Remove this comment to see the full error message
        message || { message: `${schema._label} is required` }
      );
    }

    // @ts-expect-error TS(2339): Property '_exclusive' does not exist on type 'Sche... Remove this comment to see the full error message
    if (typeof value === 'undefined' && !schema._exclusive.required) {
      return true;
    }

    if (typeof value !== 'undefined') {
      const { length } = `${value}`;

      return length < 10 || length > 11
        ? createError(
            message || {
              // @ts-expect-error TS(2551): Property '_label' does not exist on type 'Schema<a... Remove this comment to see the full error message
              message: `${schema._label} is not a valid phone number`,
            }
          )
        : true;
    }
  });
});
